export class RequestResult<T> {
  data: T;
  totalCount: number;
  success: boolean;
  code: string;
  message: string;

  constructor(data: T, totalCount: number, success: boolean, code: string, message: string) {
    this.data = data;
    this.totalCount = totalCount;
    this.success = success;
    this.code = code;
    this.message = message;
  }
}
